import { Injectable } from '@angular/core';

import { TextEncodingService } from '../../shared/services/text-encoding.service';
import { getDigest } from '../../shared/utilities/digest.utility';
import { EncryptionConfigService } from './encryption-config.service';
import { WebCryptoService } from './web-crypto.service';

@Injectable({
    providedIn: 'root'
})
export class DigestService {
    constructor(
        private readonly webCryptoService: WebCryptoService,
        private readonly encryptionConfigService: EncryptionConfigService,
        private readonly textEncodingService: TextEncodingService
    ) {
    }

    public async saltedHash(toHash: string): Promise<string> {
        const salt = this.encryptionConfigService.config.digestSaltBase64;

        return getDigest(this.webCryptoService.crypto.subtle, toHash, salt, toEncode => this.textEncodingService.encode(toEncode));
    }
}
